import {
  FETCHING_EXHIBITION_AGENDA_ENTRIES_REQUEST,
  FETCHING_EXHIBITION_AGENDA_ENTRIES_SUCCESS,
  FETCHING_EXHIBITION_AGENDA_ENTRIES_FAILURE,
  
  FETCHING_EXHIBITION_AGENDA_ENTRY_REQUEST,
  FETCHING_EXHIBITION_AGENDA_ENTRY_SUCCESS,
  FETCHING_EXHIBITION_AGENDA_ENTRY_FAILURE,

  CREATE_EXHIBITION_AGENDA_ENTRY_FAILURE,
  CREATE_EXHIBITION_AGENDA_ENTRY_SUCCESS,
  CREATE_EXHIBITION_AGENDA_ENTRY_REQUEST,

  UPDATE_EXHIBITION_AGENDA_ENTRY_FAILURE,
  UPDATE_EXHIBITION_AGENDA_ENTRY_SUCCESS,
  UPDATE_EXHIBITION_AGENDA_ENTRY_REQUEST,

  DELETE_EXHIBITION_AGENDA_ENTRY_FAILURE,
  DELETE_EXHIBITION_AGENDA_ENTRY_SUCCESS,
  DELETE_EXHIBITION_AGENDA_ENTRY_REQUEST,
} from '../actions/types';
import ResponseService from '../../utils/ResponseService';
import ApplicationError from '../../utils/ApplicationError';

const initialState = {
  agendaEntries: [],
  agendaEntry: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData()
};

const agendaEntriesReducer = (state = initialState, action ) => {
  switch(action.type) {
    case FETCHING_EXHIBITION_AGENDA_ENTRIES_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_EXHIBITION_AGENDA_ENTRIES_SUCCESS:
      return {...state, isFetching: false, 
        agendaEntries: action.payload.objects, 
        error: ApplicationError.buildDefault(),
        ...action.payload.paginationData }

    case FETCHING_EXHIBITION_AGENDA_ENTRIES_FAILURE:
      return {...state, isFetching: false, error: action.payload }
    
    case FETCHING_EXHIBITION_AGENDA_ENTRY_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_EXHIBITION_AGENDA_ENTRY_SUCCESS: 
      return {...state, isFetching: false, agendaEntry: action.payload, error: ApplicationError.buildDefault() }
    case FETCHING_EXHIBITION_AGENDA_ENTRY_FAILURE:
      return {...state, isFetching: false, error: action.payload }  

    case  CREATE_EXHIBITION_AGENDA_ENTRY_REQUEST:
      return {...state, isFetching: true }
    case  CREATE_EXHIBITION_AGENDA_ENTRY_SUCCESS:
      return {...state, isFetching: false, agendaEntry: action.payload, error: ApplicationError.buildDefault() }
    case  CREATE_EXHIBITION_AGENDA_ENTRY_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    case  UPDATE_EXHIBITION_AGENDA_ENTRY_REQUEST:
      return {...state, isFetching: true }
    case  UPDATE_EXHIBITION_AGENDA_ENTRY_SUCCESS:
      return {...state, isFetching: false, agendaEntry: action.payload, error: ApplicationError.buildDefault() }
    case  UPDATE_EXHIBITION_AGENDA_ENTRY_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    case  DELETE_EXHIBITION_AGENDA_ENTRY_REQUEST:
      return {...state, isFetching: true }
    case  DELETE_EXHIBITION_AGENDA_ENTRY_SUCCESS:
      return {...state, isFetching: false, error: ApplicationError.buildDefault() }
    case  DELETE_EXHIBITION_AGENDA_ENTRY_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    default: 
      return state
  }
}

export default agendaEntriesReducer;